import { useMutation } from '@tanstack/react-query';
import { chat, chatAuth } from '../web/clients';


export const useChatAuth = () => {
    return useMutation({
        mutationFn: async ({token}: {token: string}) => {
            return chatAuth(token);
        },
    });
};

export const useChat = () => {
    return useMutation({
        mutationFn: async ({query}: {query: string}) => {
            return chat(query);
        },
    });
};